import React, { useState, useEffect } from 'react';
import {
    IonModal,
    IonButton,
    IonButtons,
    IonCheckbox,
    IonContent,
    IonHeader,
    IonItem,
    IonLabel,
    IonList,
    IonTitle,
    IonSearchbar,
    IonToolbar,
    IonIcon,
    IonRadioGroup,
    IonRadio
} from '@ionic/react';
import styles from "../Css/CustomSelectorSearch.module.scss";
import { checkmark, close} from 'ionicons/icons';

const CustomSelectorSearch = ({ open, tittle, onSelectionCancel, onSelectionConfirm, data, identifier, description, selectedItems = [], 
    returnObject = false, multiple = false, placeholder = 'Buscar'}) => {
    const [filteredItems, setFilteredItems] = useState(data);
    const [workingSelectedValues, setWorkingSelectedValues] = useState(selectedItems);
    const [valueSelected, setValueSelected] = useState('');
    
    useEffect(() => {
        if(open){
            setFilteredItems(data);
            selectedDefault();
        }
        // eslint-disable-next-line
    }, [open]);

    const searchbarInput = (ev: any) => {
        filterList(ev.target.value);
    };

    const filterList = (searchQuery: string | null | undefined) => {
        if (searchQuery === undefined || searchQuery === null) {
            setFilteredItems(data);
        } else {
            const normalizedQuery = searchQuery.toLowerCase();
            setFilteredItems(
                data.filter((item) => {
                    return item[description].toLowerCase().includes(normalizedQuery);
                })
            );
        }
    };

    const selectedDefault = () => {
        if(returnObject){
            const listItem = selectedItems.map(item => item[identifier]);
            if(listItem.length > 0){
                (multiple)? setWorkingSelectedValues(listItem) : setValueSelected(listItem[0]);
            }else {
                (multiple)? setWorkingSelectedValues([]) : setValueSelected('');
            }
        } else {
            if(selectedItems.length > 0){
                (multiple)? setWorkingSelectedValues(selectedItems) : setValueSelected(selectedItems[0]);
            } else {
                (multiple)? setWorkingSelectedValues([]) : setValueSelected('');
            }
        }
    }

    const isChecked = (value) => {
        return workingSelectedValues.find((item) => item === value) !== undefined;
    };

    const checkboxChange = (ev) => {
        const { checked, value } = ev.detail;
        if (checked) {
            setWorkingSelectedValues([...workingSelectedValues, value]);
        } else {
            setWorkingSelectedValues(workingSelectedValues.filter((item) => item !== value));
        }
    };

    const radioChange = (ev) => {
        const { value } = ev.detail;
        setValueSelected(value);
    }

    function filterObjectSelect(){
        let response;
        if(multiple){
            response = data.filter((item) => workingSelectedValues.includes(item[identifier]));
        } else {
            response = data.filter((item) => item[identifier] === valueSelected);
        }
        return response;
    }

    const confirmSelect = () => {
        let response;
        if(returnObject){
            response = filterObjectSelect();
        } else{
            if(multiple){
                console.log(workingSelectedValues);
                response = workingSelectedValues;
            } else {
                response = [valueSelected];
            }
        }

        onSelectionConfirm(response);
    }

    return (
        <IonModal id="search-modal" isOpen={open}>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton onClick={onSelectionCancel}>
                            <IonIcon icon={close} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle className={styles.tittle} text-center>{tittle}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={confirmSelect}>
                            <IonIcon icon={checkmark} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                <IonToolbar>
                    <IonSearchbar onIonInput={searchbarInput} placeholder={placeholder}></IonSearchbar>
                </IonToolbar>
            </IonHeader>
            <IonContent color="light" class="ion-padding">
                <IonList id="modal-list" inset={true}>
                    {multiple === true && (
                        filteredItems.map((item) => (
                            <IonItem key={item[identifier]}>
                                <IonLabel>{item[description]}</IonLabel>
                                <IonCheckbox
                                    value={item[identifier]}
                                    checked={isChecked(item[identifier])}
                                    onIonChange={checkboxChange}
                                    color="danger"
                                />
                            </IonItem>
                        ))
                    )}
                    {multiple === false && (
                        <IonRadioGroup allowEmptySelection={true} value={valueSelected}  onIonChange={radioChange}>
                            {filteredItems.map((item) => (
                                <IonItem key={item[identifier]}>
                                    <IonLabel>{item[description]}</IonLabel>
                                    <IonRadio 
                                        slot="end" 
                                        value={item[identifier]}
                                        color="danger"
                                    />
                                </IonItem>
                            ))}
                        </IonRadioGroup>
                    )}
                </IonList>
            </IonContent>
        </IonModal>
    );
};

export default CustomSelectorSearch;